import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Helping from '../../helpers/Helping';
import Notification from "../layout/Notification";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import Service from '../../helpers/service';
import { USERS, MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import route from '../../config/routes';
import { trackPromise } from 'react-promise-tracker';

const { NOT_FOUND, DOWNLOAD_FAILED, DOWNLOAD_DATA_NOT_FOUND, DOWNLOAD_START } = MESSAGE;
class Detail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: URL + 'users',
      detail: undefined,
      users: undefined,
      isLoading: true,
      isLoadingUsers: true,
      total: 0,
      page: 1,
      limit: USERS.LIMIT,
      pageTitle: 'redeem code detail',
      search: '',
      sorting: 'id',
      sort_type: 'DESC',
      sort_class: 'fa fa-sort-up',
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.sortBy = this.sortBy.bind(this);
  }

  setErrorOnApiCall = () => {
    setProfileError(res => this.setState({ ...res }));
  }

  removeNetworkError = () => {
    this.setState({ ...Helping.clearNetworkRequest() });
  }

  componentDidMount() {
    const { pathname, error_message } = this.props.location;

    this.setState({
      routeName: pathname,
      error_message: error_message
    });
    this.props.addCurrentRoute(this.props.profile, pathname);

    this.setErrorOnApiCall();
    this.getRedeemDetail();
    this.getRedeemUserList();
  }

  pageRefreshFunction = () => {
    this.setState({
      search: ''
    }, () => this.getRedeemUserList());
  }

  getRedeemDetail = () => {
    trackPromise(
      Service.postCall(API_URL.ADMIN_TRADING_API + route.GET_REDEEM, {
        action: 'get-by-id',
        id: this.props.match.params.id,
      }).then(response => {
        this.setState({ detail: response.data.payload, isLoading: false })
      })
        .catch(error => {
          if (error.response) {
            Helping.redirectToLogin(error);
            return this.setState(
              {
                error_message: error.response.data.message,
                error_type: 'danger',
                isLoading: false,
              });
          }
          return this.setState(
            {
              isLoading: false,
              ...Helping.setNetworkRequestError(error, 'fetching redeem'),
            });
        })
    )
  }

  getRedeemUserList = () => {
    const { id } = this.props.match.params;

    Service.postCall(API_URL.ADMIN_TRADING_API + route.GET_REDEEM, {
      action: 'list-applied-users',
      redemption_id: id,
      page: this.state.page,
      limit: this.state.limit,
      sorting: 'id',
      search: this.state.search,
      sort_type: 'DESC',
    }).then(response => {
      const { users, count } = response.data.payload;
      this.setState({ users: users, total: count, isLoadingUsers: false })
    })
      .catch(error => {
        console.log({ error })
        if (error.response) {
          Helping.redirectToLogin(error);
          return this.setState(
            {
              error_message: error.response.data.message,
              error_type: 'danger',
              isLoading: false,
            });
        }
        return this.setState(
          {
            isLoading: false,
            ...Helping.setNetworkRequestError(error, 'fetching users'),
          });
      });

  }

  handlePageChange(pageNumber) {
    if (this.state.page === pageNumber) {
      return false;
    }

    this.setState({
      page: pageNumber,
      isLoadingUsers: true
    }, () => {
      this.getRedeemUserList();
    });
  }

  onChangeStartDate = date => {
    this.setState({ startDate: date })
  }
  onChangeEndDate = date => {
    this.setState({ endDate: date })
  }

  handleSearchChange(e) {
    let $this = this,
      searchValue = e.target.value.replace(/^\s+/g, '');

    this.setState({
      search: searchValue,
      activePage: 1
    }, () => {
      if (searchValue.length > 0) {
        $this.getRedeemUserList();
      }

      if (searchValue.length === 0) {
        $this.getRedeemUserList();
      }
    });
  }

  isEnabled(enable) {
    if (enable) {
      return (
        <label style={{ color: "green" }}>Enabled</label>
      )
    }

    return (
      <label style={{ color: "red" }}>Disabled</label>
    )
  }

  downloadUserList = () => {
    const downloadButton = document.getElementById("downloadUsers");
    Service.postCall(API_URL.ADMIN_TRADING_API + route.GET_REDEEM, {
      action: 'list-applied-csv',
      redemption_id: this.props.match.params.id,
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState(
            {
              error_message: Helping.getMessageString(
                DOWNLOAD_START,
                `user list`
              ),
              error_type: 'success',
              downloadUrl: response.data.payload.url,
            },
            () => {
              downloadButton.click();
            }
          );
        }
      })
      .catch((error) => {
        console.log({ error });
        this.setState(
          {
            error_message:
              error.response.data.message &&
                error.response.data.message.includes('not found')
                ? Helping.getMessageString(DOWNLOAD_DATA_NOT_FOUND, 'users')
                : Helping.getMessageString(DOWNLOAD_FAILED, `user list`),
            error_type: 'danger',
          });
      });
  }

  sortBy(key) {
    let $this = this;
    let sortType = this.state.sort_type;
    let sortClass = this.state.sort_class;

    if (this.state.sort_type === 'ASC') {
      sortType = 'DESC';
      sortClass = "fa fa-sort-down";
    }

    if (this.state.sort_type === 'DESC') {
      sortType = 'ASC';
      sortClass = "fa fa-sort-up";
    }

    this.setState({
      sorting: key,
      activePage: 1,
      is_order: true,
      sort_type: sortType,
      sort_class: sortClass,
    }, () => {
      $this.getusers();
    });
  }

  render() {
    let { detail, users, total } = this.state;

    return (
      <div class="content user-view">
        {detail && (
          <>
            <div class="top-header">
              <div class="header-title">
                <h2 class="title">{detail.code}</h2>
                <span class="title-caption">{detail.is_active ? 'active' : 'deactive'}</span>
              </div>

              <div class="header-btn">
                <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                    <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                      <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                        <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                        <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                      </g>
                    </g>
                  </svg>
                  <span class="txt-btn">Back</span>
                </button>

                {total > 0 &&
                  <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.downloadUserList}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="15.5" viewBox="0 0 15.5 15.5">
                      <g id="report" transform="translate(0.75 0.75)">
                        <path id="Path_344" data-name="Path 344" d="M4.75,14.75v1.5a2.949,2.949,0,0,0,2.9,3h8.207a2.949,2.949,0,0,0,2.9-3v-1.5" transform="translate(-4.75 -5.25)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                        <path id="Path_345" data-name="Path 345" d="M12,14.25V4.75" transform="translate(-5 -4.75)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                        <path id="Path_346" data-name="Path 346" d="M8.75,10.75,12,14.25l3.25-3.5" transform="translate(-5 -5.023)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                      </g>
                    </svg>
                    <span class="txt-btn">Export</span>
                  </button>
                }
                <a href={this.state.downloadUrl} style={{ display: 'none' }} id='downloadUsers' target='_blank' rel='noopener noreferrer' download >
                  <i className='fas fa-download' />
                  Download File
                </a>

              </div>
            </div>
            {this.state.error_message && (
              <Notification
                type={this.state.error_type}
                message={this.state.error_message}
                callback={this.removeNetworkError}
              />
            )}

            <div class="main-content  view-page-content">
              <div class="view-tabs double-tabs">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#redeemDetail" role="tab">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                        <path id="Path_380" data-name="Path 380" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,2a8,8,0,1,1-8,8A8,8,0,0,1,12,4Zm0,11a1,1,0,1,1-1,1A1,1,0,0,1,12,15Zm1-7v5a1,1,0,0,1-2,0V8a1,1,0,0,1,2,0Z" transform="translate(-2 -2)" />
                      </svg>
                      <span class="tab-text">Details</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#usersInfo" role="tab">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
                        <path id="user" d="M12,2a4.985,4.985,0,1,0,5,4.984A4.993,4.993,0,0,0,12,2Zm0,1.994a2.991,2.991,0,1,1-3,2.99A3,3,0,0,1,12,3.994Zm2,8.972a5.99,5.99,0,0,1,6,5.981v2.025a1,1,0,0,1-2,0V18.947a3.994,3.994,0,0,0-4-3.987H10a3.994,3.994,0,0,0-4,3.987V21a1,1,0,0,1-2,0V18.947a5.99,5.99,0,0,1,6-5.981Z" transform="translate(-4 -2)" />
                      </svg>
                      <span class="tab-text">User's Info</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-content">
                <div class="tab-pane active" id="redeemDetail" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-6 col-md-6 col-lg-4">
                      <ul class="list-view">
                        <li>
                          <label for="">Code</label>
                          <span>{detail.code}</span>
                        </li>
                        <li>
                          <label for="">Limit</label>
                          <span>{detail.max_limit ? Number(detail.max_limit) : 0}</span>
                        </li>
                        <li>
                          <label for="">Remaining</label>
                          <span>{detail.remaining ? Number(detail.remaining) : 0}</span>
                        </li>
                        <li>
                          <label for="">Active</label>
                          <span>{detail.is_active ? "Yes" : "No"}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-5">
                      <ul class="list-view">
                        <li>
                          <label for="">Deleted</label>
                          <span>{detail.is_deleted ? "Yes" : "No"}</span>
                        </li>
                        <li>
                          <label for="">Started At</label>
                          <span>
                            {Helping.convertTimeToHumanReadableFormat(
                              Helping.convertUnixTimeStampToDateTime(
                                detail.start_date
                              )
                            )}
                          </span>
                        </li>
                        <li>
                          <label for="">Expire At</label>
                          <span>
                            {Helping.convertTimeToHumanReadableFormat(
                              Helping.convertUnixTimeStampToDateTime(
                                detail.end_date
                              )
                            )}
                          </span>
                        </li>
                        <li>
                          <label for="">Created at</label>
                          <span>{Helping.convertTimeToHumanReadableFormat(detail.created_at)}</span>
                        </li>
                      </ul>
                    </div>

                    {detail.description &&
                      <div class="col-sm-12 col-md-12 col-lg-12">
                        <ul class="list-view">
                          <li>
                            <label for="">Description</label>
                            <span>{detail.description}</span>
                          </li>
                        </ul>
                      </div>}
                  </div>
                </div>
                <div class="tab-pane" id="usersInfo" role="tabpanel">
                  <div class="listing-tbl table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col" class="userFullName">Full Name</th>
                          <th scope="col">Username</th>
                          <th scope="col">Applied Date</th>
                          <th scope="col">Public Key</th>
                        </tr>
                      </thead>
                      <tbody>
                        {total > 0 && users.map((user, i) => (
                          <tr key={i}>
                            <td scope="row">{user.id}</td>
                            <td>
                              <div class="user-info">
                                <img src={user.avatarUrl ? user.avatarUrl : "/img/default_user_img.png"}
                                  alt="" class="img-fluid user-img" />
                                <div class="info">
                                  <h5 class="name">{user.first_name + ' ' + user.last_name}</h5>
                                  <p class="email">{user.email}</p>
                                </div>
                              </div>
                            </td>
                            <td>{user.username}</td>
                            <td>{Helping.convertTimeToHumanReadableFormat(user.applied_date)}</td>
                            <td>{user.pub_key}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {(!detail && !this.state.isLoading) && (
          <div className="table-responsive">
            <Notification type="danger"
              message={Helping.getMessageString(NOT_FOUND, "Redeem")}
              callback={this.removeNetworkError}
            />
          </div>
        )
        }
      </div>
    );
  }
}
const mapStateToProps = state => ({
  profile: state.profile
});

const mapDispatchToProps = {
  addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);